import { FeatureFlags } from '../../../common/model/config';

export const eldoradoFeatureFlags: FeatureFlags = {
  hideBackButton: false,
};
